<template src="./sidebar.html" />
<style scoped src="./sidebar.css" />
<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      menu: [
        {
          title: 'Dashboard',
          href: '/dashboard',
          icon: 'fa fa-dashboard',
          hidden: false
        },
        {
          title: 'Accounts',
          icon: 'fa fa-users',
          hidden: false,
          child: [
            {
              title: 'Manage Merchant',
              href: '/manageMerchant',
              hidden: false
            },
            {
              title: 'Manage POS',
              href: '/managePOS',
              hidden: false
            },
            {
              title: 'Manage API Keys',
              href: '/merchantApiKey',
              hidden: false
            },
            {
              title: 'Configuration Webhooks',
              href: '',
              hidden: false
            },
            {
              title: 'Manage Customers',
              href: '/manageCustomers',
              hidden: false
            }
          ]
        },
        {
          title: 'Payment Gateways',
          icon: 'fa fa-university',
          hidden: false,
          child: [
            {
              title: 'Manage Gateways',
              href: '/manageGateways',
              hidden: false
            },
            {
              title: 'Merchant gateways',
              href: '/manageMerchantGateways',
              hidden: false
            },
            // {
            //   title: 'Payment Method Config',
            //   href: '',
            //   hidden: false
            // }
          ]
        },
        {
          title: 'Payment Routing',
          icon: 'fa fa-external-link',
          hidden: false,
          child: [
            {
              title: 'Routing Template',
              href: '/manageRoutingTemplate',
              hidden: false
            },
            {
              title: 'Routing Rules',
              href: '/manageRoutingRules',
              hidden: false
            },
            {
              title: 'Business Attributes',
              href: '/manageBusinessAttributes',
              hidden: false
            }
          ]
        },
        {
          title: 'Transactions',
          icon: 'fa fa-money',
          hidden: false,
          child: [
            {
              title: 'Payments',
              href: '/payments',
              hidden: false
            },
            {
              title: 'Purchase',
              href: '/purchase',
              hidden: false
            },
            {
              title: 'Refunds',
              href: '/refundTransactions',
              hidden: false
            },
            {
              title: 'Payment Link',
              href: '/orderTransactions',
              hidden: false
            },
            {
              title: 'Virtual Cards',
              href: '/manageVirtualCards',
              hidden: false
            }
          ]
        },
        {
          title: 'System',
          icon: 'fa fa-laptop',
          hidden: false,
          child: [
            {
              title: 'Merchant Admin',
              href: '/userMerchantConfiguration',
              hidden: false
            },
            {
              title: 'Manage Users',
              href: '/manageUser',
              hidden: false
            },
            {
              title: 'Manage Roles',
              href: '/addRolePermission',
              hidden: false
            }
          ]
        },
        {
          title: 'Reports',
          icon: 'fa fa-newspaper-o',
          hidden: false,
          child: [
            {
              title: 'Transaction Summary',
              href: '/ordersummary',
              hidden: false
            }
          ]
        },
        {
          title: 'Events',
          icon: 'fa fa-linode',
          hidden: false,
          child: [
            {
              title: 'Transaction Logs',
              href: '/transactiontrace',
              hidden: false
            },
          ]
        }
      ],
      isOnMobile: false,
      collapsed: false,
      themes: [
        {
          name: 'Default theme',
          input: ''
        },
        {
          name: 'White theme',
          input: 'white-theme'
        }
      ],
      isOnMobile: false,
      sidebardwith: '350px'
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onToggleCollapse(collapsed) {
      if (window.innerWidth <= 876 && !collapsed) {
        this.collapsed = collapsed
      } else {
        this.collapsed = collapsed
        this.$emit('toggle-collapse', this.collapsed)
      }
    },
    onResize() {
      if (window.innerWidth <= 876) {
        this.collapsed = true
        this.isOnMobile = true
      } else {
        this.collapsed = false
        this.isOnMobile = false
      }
    }
  }
}

</script>